// useLanguage.js
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';

export function useLanguage() {
    const { locale } = useI18n();

    const languagesDetails = {
        en: {
            name: 'English',
            flagCode: 'us',
            locale: 'en',
            bcp47: 'en-US',
            dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
        },
        sl: {
            name: 'Slovenščina',
            flagCode: 'si',
            locale: 'sl',
            bcp47: 'sl-SI',
            dayNames: ['P', 'T', 'S', 'Č', 'P', 'S', 'N'],
        },
    };

    const languages = computed(() =>
        Object.entries(languagesDetails).map(([id, details]) => ({ id, ...details }))
    );

    const localizedDayNames = computed(() => {
        const currentLanguage = languages.value.find((lang) => lang.locale === locale.value);
        return currentLanguage ? currentLanguage.dayNames : languagesDetails['en'].dayNames;
    });

    const changeLanguage = (langId) => {
        console.log('changing language to:', langId);

        const newLocale = languagesDetails[langId]?.locale || 'en';

        if (locale.value !== newLocale) {
            locale.value = newLocale;
            localStorage.setItem('userLanguage', newLocale);

            console.log('In locale storage we have now:', localStorage.getItem('userLanguage'));

            axios
                .post('/set-language', { lang: newLocale })
                .then((response) => console.log('Language change response:', response))
                .catch((error) => console.log('Language change error:', error));
        }
    };

    const fetchUserLanguage = () => {
        const storedLang = localStorage.getItem('userLanguage');
        if (storedLang) {
            // If we already have a stored language, don't override it.
            return;
        }

        axios
            .get('/get-language')
            .then((response) => {
                const fetchedLang = response.data.language;
                if (fetchedLang && languagesDetails[fetchedLang]) {
                    changeLanguage(fetchedLang);
                }
            })
            .catch((error) => console.error('Failed to fetch user language:', error));
    };

    const getBCP47Locale = () => {
        const currentLanguageDetail = languagesDetails[
            Object.keys(languagesDetails).find(
                (key) => languagesDetails[key].locale === locale.value
            )
            ];
        return currentLanguageDetail ? currentLanguageDetail.bcp47 : locale.value;
    };

    const initializeLanguage = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const langParam = queryParams.get('lang');

        if (langParam && languagesDetails[langParam]) {
            // If a valid lang param is present, use it
            changeLanguage(langParam);
        } else {
            // Otherwise use localStorage or fallback to 'en'
            const storedLanguage = localStorage.getItem('userLanguage') || 'en';
            changeLanguage(storedLanguage);
        }

        // After setting initial language, optionally fetch user language from server
        fetchUserLanguage();
    };

    return {
        locale,
        languages,
        changeLanguage,
        getBCP47Locale,
        localizedDayNames,
        initializeLanguage,
    };
}
